import React, { PureComponent } from 'react';
import {
  getAvailableValuesBasedOnSelection,
  getBlocksBasedOnSelection,
  getAddonNameBasedOnSelection,
} from './utils/tools';
import { getNodeInfo } from '../../../helper/config';
import Dropdown from '../standardAttributes/Dropdown';
import message from '../../../helper/message';

export default class AboveToolAddOns extends PureComponent {
  onChange = async (ev, { value }) => {
    const {
      models,
      selectedModel,
      attributeName,
      actions,
      appApi,
      setAppState,
      getAppState,
      activeTab,
    } = this.props;
    const blocks = getBlocksBasedOnSelection(this.props);
    const block = blocks.track;
    let newAppState = getAppState();
    const modelId = models[selectedModel].children.find(
      id => models[id].attribute === attributeName
    );

    if (modelId) {
      block.unoccupyBlocks(modelId);
      newAppState = actions.removeModel(modelId, newAppState);
      newAppState = actions.setConfiguration(
        {
          attribute: attributeName,
          value: models[modelId].value,
          change: modelId,
        },
        newAppState
      );
    }
    if (value !== 'None') {
      const product = appApi.config.getProduct(value);
      const nodeInfo = getNodeInfo(product, 'depth');
      const insertion = block.determineInsertion(nodeInfo);
      if (!insertion.isInsertionPossible) {
        message.error(
          `Fail to insert ${attributeName}, please check either the dimension  or the compatibility of product ${value}!`
        );
        return setAppState(newAppState);
      }
      setAppState({ disabled: true });
      const transform = block.getInsertTransform(insertion);
      const importOptions = { parent: selectedModel, transform };
      const importState = await appApi.model.importModel(
        product.sceneId,
        importOptions
      );
      block.occupyBlocks(importState.modelId, insertion);
      newAppState = actions.addModel(
        importState,
        {
          tab: activeTab,
          attribute: attributeName,
          value,
          parent: selectedModel,
        },
        newAppState,
        false
      );
      newAppState = actions.setConfiguration(
        { attribute: attributeName, value, change: importState },
        newAppState
      );
    }

    setAppState(newAppState);
  };

  render() {
    const dropdownOptions = getAvailableValuesBasedOnSelection(this.props);
    const dropdownValue = getAddonNameBasedOnSelection(this.props);
    return (
      <Dropdown
        {...this.props}
        options={dropdownOptions}
        value={dropdownValue}
        onChange={this.onChange}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Attributes/nonStandardAttributes/AboveToolAddOns.js